<h2 mat-dialog-title>Download File</h2>
<div mat-dialog-content>
  <mat-form-field appearance="fill" style="width:100%">
    <mat-label>Remote Path</mat-label>
    <input matInput [(ngModel)]="remotePath" placeholder="/path/to/remote/file" />
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onDownload()" [disabled]="!remotePath">Download</button>
</div>
